<script setup lang="ts">
defineProps<{ message: string }>();
</script>

<template>
  <span class="tooltip tooltip-left inline-flex" :data-tip="message">
    <button type="button" class="btn btn-ghost btn-sm btn-square text-info" :aria-label="`Thông tin quyền: ${message}`">
      <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
    </button>
  </span>
</template>
